
export const login = "/token/generate"
export const resfresh = "/token/refresh-token"
export const editMember = "/base/member/edit"
export const findMember = "/base/member/search"
export const getAllMember = "/base/member/get"
export const getMemberById = "/base/member/byId"
export const deleteMemberById = "/base/member/delete"
export const changePassword = "/base/change/password"
export const uploadImageFile = "/file/upload/files/:folderName/:referenceName"
export const getWaitingRequestBecome = "/base/member/wait/approve/become"
export const approveRejectBecome = "/base/approve/become"
export const getDeviceNotification = "/base/device/allow/notification"
export const addDeviceNotification = "/base/device/allow/notification/add"
export const deleteDeviceNotification = "/base/device/allow/notification/delete"

//# setting
//Vehicle Brand
export const getVehicleBrand = "/base/vehicleBrand/get/all"
export const getVehicleBrandById = "/base/vehicleBrand/get/byId"
export const addVehicleBrand = "/base/vehicleBrand/add"
export const editVehicleBrand = "/base/vehicleBrand/edit"
export const deleteVehicleBrand = "/base/vehicleBrand/delete"
//Policy
export const getPolicy = "/base/policy/get/all"
export const getPolicyById = "/base/policy/get/byId"
export const addPolicy = "/base/policy/add"
export const editEditPolicy = "/base/policy/edit"
export const deletePolicy = "/base/policy/delete"
export const getPolicyTypeAll = "/base/policyType/getAll"
//User Management
export const getUserManagement = "/base/user/get/all"
export const getUserManagementById = "/base/user/get/byId"
export const addUserManagement = "/base/user/add"
export const editUserManagement = "/base/user/edit"
export const deleteUserManagement = "/base/user/delete"
export const searchUserByKey = "/base/user/search"
//Load Address
export const getAllProvince = "/base/province/getAll"
export const getDistrict = "/base/district/byProvinceId"
export const getRoles = "/base/roles/getAll"
//Change password
export const cmsChangePassword = "/authen/cms/changePassword"
//Special Agent Commission
export const getSpecialAgentCommision = "/base/special-commission/get"
export const getSpecialAgentCommisionById = "/base/special-commission/getById"
export const addSpecialAgentCommision = "/base/special-commission/add"
export const editSpecialAgentCommision = "/base/special-commission/update"
export const deleteSpecialAgentCommision = "/base/special-commission/delete"
export const getSearchAgentInfo = "/agent/search-agent"
export const approveRejectedSpecialAgentCommision = "/base/special-commission/approveReject"
//Upload FIle
export const uploadFile = "/file/upload/files/:folderName/:referenceName"
export const deleteFile = "/file/delete/file"

//User Permission
export const getMainMenu = "/base/admin/main-menu/get"
export const getSubMenuByKey = "/base/admin/sub-menu/get"
export const grandPermission = "/base/grand/user-permission"
export const getGrandUserPerssion = "/base/grand/user-permission/get"
export const deleteGrandUserPerssion = "/base/grand/user-permission/delete"
export const getGrandUserPerssionById = "/base/grand/user-permission/edit/get"
export const getPermissionControls = "/base/admin/permission-control/get"
export const saveWebMenu = "/base/admin/web-menu/save"
export const deleteWebMenu = "/base/admin/web-menu/delete"
// User Action Log
export const getUserActionLogsURL = "/action-log/getAll"
export const getUserActionLogByIdURL = "/action-log/getById"

//Notification
export const getRequestNotification = "/base/admin/notification/get"
export const addRequestNotification = "/base/admin/notification/add"
export const deleteRequestNotification = "/base/admin/notification/delete"
export const requestNotificationById = "/base/admin/notification/get/byId"
export const getNotificationErrorById = "/base/admin/notification/sendError/getById"
//App controls
export const getAppControls = "/base/admin/appControl/get"
export const getAppControlsById = "/base/admin/appControl/get/byId"
export const addAppControls = "/base/admin/appControl/add"
export const editAppControls = "/base/admin/appControl/edit"
export const deleteAppControls = "/base/admin/appControl/delete"
//Dashboard
export const getDashboard = "/base/dashboard/get"
//Discount
export const getDiscounts = "/base/discount/get"
export const getDiscountsById = "/base/discount/getById"
export const addDiscounts = "/base/discount/add"
export const editDiscounts = "/base/discount/edit"
export const deleteDiscounts = "/base/discount/delete"
//Approve Life Insurance
export const getLifeInsuranceClaiming = "/claim/life-insurance/get"
export const getVehicleInsuranceClaiming = "/claim/vehicle-insurance/get"
export const approveRejectLifeInsuranceClaim = "/claim/life-insurance/approveReject"
//Callcenter
export const searchUser = "/customer/cms/search-user"
export const searchCustomer = "/customer/cms/search-customer"
export const resetPassword = "/authen/cms/reset-password-users"
export const unlockAccount = "/authen/cms/unlock-users"
export const changeDeviceNoti = "/base/admin/change-device-notification"
export const paymentHistory = "/payment/history"
export const customerById = "/customer/cms/getById"
export const postCustomer = "/customer/cms/edit"
export const postAddCustomer = "/customer/cms/add"

// Manual payment recovery
export const manualPaymentPermissionsURL = "/manual-payment/permissions"
export const manualPaymentCandidatesURL = "/manual-payment/candidates"
export const manualPaymentCasesURL = "/manual-payment/cases"
export const manualPaymentCaseByIdURL = "/manual-payment/cases/:id"
export const manualPaymentSubmitURL = "/manual-payment/cases/:id/submit"
export const manualPaymentDecisionURL = "/manual-payment/cases/:id/decision"
export const manualPaymentSyncURL = "/manual-payment/cases/:id/sync"
export const manualPaymentSlipURL = "/manual-payment/cases/:id/slip"
export const manualPaymentPreflightURL = "/manual-payment/cases/:id/preflight"
export const manualPaymentFinalizeURL = "/manual-payment/cases/:id/finalize"
//contract
export const getPaymentURL = "/contract/getPayment"
export const getPaymentDetailURL = "/contract/getPaymentDetail"

export const getContractByKeyURL = "/contract/getContractByKey"
export const getVehicleCaseIdiomsURL = "/claim/vehicle-case-idioms/get"
export const getContractDetailURL = "/contract/getContractDetail"
export const cancelContractURL = "/contract/cancelContract"
export const getActiveLifePackageURL = "/package/getActiveLifePackage"
export const registerCustomerURL = "/payment/paymentLifeInsurance"
export const registerVehicleURL = "/payment/paymentVehicleInsurance"
export const getLifeContractURL = "/contract/getLifeContract"
export const getVehiclesContractURL = "/contract/getVehiclesContract"
export const editCustomerURL = "/customer/edit"
export const editVehiclesURL = "/customer/editVehicles"
export const callCancelContractVehicleURL = "contract/request/cancel-vehicle-contract"
export const getCancelContractURL = "/contract/request-cancel-contract/get"
export const approveCancelContractURL = "/contract/approveReject/cancel-vehicle-contract"
export const getApproveContractURL = "/claim/insurance/getById"
export const approveContractURL = "/claim/insurance/approveReject"
export const addVehicleCaseIdiomsURL = "/claim/vehicle-case-idioms/add"

export const updateVehicleCaseIdiomsURL = "/claim/vehicle-case-idioms/update"
export const getVehicleCaseIdiomsByIdURL = "/claim/vehicle-case-idioms/getById"
export const getVehicleCaseIdiomsByContractURL = "/claim/vehicle-case-idioms/getByContract"
export const getVehicleCaseIdiomsAllByContractURL = "/claim/vehicle-case-idioms/getAllByContract"
export const deleteVehicleCaseIdiomsURL = "/claim/vehicle-case-idioms/delete"
export const resetVehicleCaseIdiomsURL = "/claim/vehicle-case-idioms/reset"
export const checkRenewURL = "/contract/checkRenew"
export const checkContractNumberURL = "/contract/checkContractNumber"
export const redisInfoURL = "/redis/info"
export const redisInfoBykeyURL = "redis/keys"
export const redisBykeyURL = "redis/key"
export const redisDeleteURL = "redis/key"
export const redisUpdateTTLURL = "redis/ttl"
export const redisFlushURL = "redis/flush-db"

export const updateStatusClameContractURL = "/claim/insurance/updateStatus"











export const claimLifeInsurnaceURL = "/claim/request/claim/insurance"
export const getActiveVehicleTypeURL = "/base/vehiclesType/getAll"
export const getActiveVehiclePackageURL = "/package/getVehiclePackageByCarType"

//Agents
export const generateCode = "/agent/generateCode"
export const addAgent = "/agent/add"
export const getAgentById = "/agent/get/byId"
export const cancelAgent = "/agent/cancel-agent"
export const searchReqCancelAgentURL = "/agent/search-req-cancel"
export const approvedOrRejectCancelAgentURL = "/agent/approved-or-reject"
export const checkCancelAgentURL = "/agent/get-cancel-agent"



export const editAgent = "/agent/edit"

//Export
export const getExportAgent = "/agent/export/agent/get"
export const getExportClameURL = "/claim/export/get"
export const getExportClameSummaryURL = "/claim/vehicle-report-claim-summary/get"
export const exportExcelClameURL = "/export/claim/excel"
export const exportExcelClameSummaryURL = "/export/vehicle-report-claim-summary/excel"
export const exportExcelSummaryURL = "/export/vehicle-report-summary/excel"
export const exportAgent = "/export/agent/excel"
export const getExportCustomer = "/customer/export/customer/get"
export const exportCustomer = "/export/customer/excel"
export const getExportNearlyExpired = "/base/export/nearExpired/get"
export const exportNearlyExpired = "/export/vehicle/nearExpired/excel"
export const getExportRiskVehicleContract = "/contract/export/riskVehicleContract/get"
export const exportRiskVehicleContract = "/export/riskVehicleContract/excel"
export const getExportAgentCommission = "/contract/export/agentCommission/get"
export const exportAgentCommission = "/export/agentCommission/excel"
export const getExportLifeContract = "/contract/report/life-insurance/get"
export const exportLifeContract = "/export/report-life-contract/excel"
export const getExportVehicleContract = "/contract/report/vehicle-insurance/get"
export const exportVehicleContract = "/export/report-vehicle-contract/excel"
export const exportLifeContractPDF = "/export/lifeContract/pdf"
export const exportVehicleContractPdfURL = "/export/vehicleContract/export"
export const exportHistory = "/export/export-payment-history/excel"
export const getExportVehicleSummaryURL = "/payment/vehicle-report-payment/get"


export const exportClameContractPDF = "/export/clame/export/pdf"
export const uodateToAgentURL = "/customer/cms/user-to-agent"
export const paymentDebitURL = "/payment/payment-debit"
export const commissionDetailURL = "/payment/commissionDetail/get"
export const commissionDetailByAgentIdURL = "/payment/commissionDetail/getByAgentId"
export const approveDetailURL = "/payment/commissionDetail/approve"
export const commissionPayoutURL = "/payment/commissionPayout/get"
export const createCommissionPayoutURL = "/payment/commissionPayout/createPayout"
export const commissionDetailByPayoutIdURL = "/payment/commissionDetail/getByPayoutId"
export const approveOrRejectCommissionPayoutURL = "/payment/commissionPayout/approveOrReject"
export const commisionAgentPdfURL = "/export/commision-agent/pdf"

export const getPaymentDDURL = "/contract/vehicleContract/export/local"
export const paymentCheckByBillNumberURL = "/payment/search-payment-by-billNumber"
export const exportClameVehicleContractPDF = "/export/clame-vehicle/export/pdf"

// User Contract Access
export const getUserContractsURL =
    "/contract/admin/user-contract/list";

export const searchContractsForUserURL =
    "/contract/admin/user-contract/search";

export const attachContractToUserURL =
    "/contract/admin/user-contract/attach";

export const detachContractFromUserURL =
    "/contract/admin/user-contract/detach";
// Legacy Life Entry
export const getLegacyLifeEntryListURL = "/legacy-life-entry";
export const getLegacyLifeEntryByIdURL = "/legacy-life-entry";
export const createLegacyLifeEntryDraftURL = "/legacy-life-entry/draft";
export const updateLegacyLifeEntryDraftURL = "/legacy-life-entry";
export const submitLegacyLifeEntryURL = "/legacy-life-entry";
export const approveLegacyLifeEntryURL = "/legacy-life-entry";
export const rejectLegacyLifeEntryURL = "/legacy-life-entry";
export const uploadLegacyLifeEntryFileURL = "/file/upload/files/legacy_life_contract";


export const searchLegacyLifeContractURL = "/legacy-life-entry/bill/contracts";
export const previewLegacyLifeBillURL = "/legacy-life-entry/bill/preview";
export const createLegacyLifeBillURL = "/legacy-life-entry/bill";

export const getLegacyLifeBillRequestsURL = "/legacy-life-entry/bill/requests";
export const getLegacyLifeBillRequestByIdURL = "/legacy-life-entry/bill/requests";
export const approveLegacyLifeBillRequestURL = "/legacy-life-entry/bill/requests";
export const rejectLegacyLifeBillRequestURL = "/legacy-life-entry/bill/requests";
